/**
 * <TutorMakeupStep> — le rattrapage que le masteur absent propose à ses élèves (organism).
 *
 * L'étape `selected_makeup_occurrences` de l'ancien `ManageRDVScreen` : ses autres groupes de la
 * semaine où ses élèves pourraient rattraper le cours, à choix multiple, et une étape qu'on peut
 * passer sans rien choisir. À moins de 30 min de la séance, plus rien ne se propose : la phrase le
 * dit, les créneaux se figent.
 *
 * Ce n'est pas « Quel nouveau créneau ? » (`<RecoverySlotStep>`) : celle-ci choisit UN créneau, chez
 * un tuteur, pour l'enfant ; ici le masteur en coche plusieurs, chez lui, et chaque carte dit qui y
 * est déjà inscrit.
 */
import React from "react"

import { Stack } from "../../atoms/containers/Stack"
import { Text } from "../../atoms/typography/Text"
import { OptionCard } from "../../molecules/OptionCard"
import { formatDayTime } from "../../../ports/primary/ui/formatters/dateFormatter"
import { type UITutorMakeupOption } from "../../../ports/primary/ui/types/tutorLives"

export type TutorMakeupStepProps = {
    options: UITutorMakeupOption[]
    selectedIds: string[]
    onToggle: (id: string) => void
    /** Moins de 30 min avant la séance : plus de rattrapage à proposer. Défaut `false`. */
    tooClose?: boolean
    testID?: string
}

export function TutorMakeupStep(props: TutorMakeupStepProps) {
    const { options, selectedIds, onToggle, tooClose = false, testID } = props
    return (
        <Stack gap="3" testID={testID}>
            <Text color="text-muted">
                {tooClose
                    ? "Tu ne peux pas proposer de séances de rattrapage moins de 30 minutes avant le début de la session."
                    : "Sélectionne tes autres créneaux où ils pourraient rattraper le cours, ou passe cette étape pour ne pas proposer de rattrapage."}
            </Text>
            <Stack gap="2">
                {options.map((option) => (
                    <OptionCard
                        key={option.id}
                        label={formatDayTime(option.date, true)}
                        description={option.studentsLabel !== "" ? option.studentsLabel : "(aucun élève)"}
                        selected={selectedIds.includes(option.id)}
                        disabled={tooClose}
                        onPress={() => onToggle(option.id)}
                    />
                ))}
            </Stack>
        </Stack>
    )
}
